export const env = {
  REACT_APP_APIKEY: 'AIzaSyB1aoMeyvh0BdAaByedRT4torY5cM-BIL4',
  REACT_APP_AUTHDOMAIN: 'aldg-incidentreport.firebaseapp.com',
  REACT_APP_PROJECTID: 'aldg-incidentreport',
  REACT_APP_STORAGEBUCKET: 'aldg-incidentreport.appspot.com',
  REACT_APP_MESSAGINGSENDERID: '187783676912',
  REACT_APP_APPID: '1:187783676912:web:4d6521ff21a74e877fd335',
  REACT_APP_MEASUREMENTID: 'G-TEGTR0EGS5',
};
